"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripeAPI = void 0;
const getPaymentIntent_1 = require("./getPaymentIntent");
const createPaymentIntent_1 = require("./createPaymentIntent");
const getDepositParameters_1 = require("./getDepositParameters");
class StripeAPI {
    baseUrl;
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    getPaymentIntent = getPaymentIntent_1.getPaymentIntent;
    createPaymentIntent = createPaymentIntent_1.createPaymentIntent;
    getDepositParameters = getDepositParameters_1.getDepositParameters;
}
exports.StripeAPI = StripeAPI;
//# sourceMappingURL=index.js.map